<div class="p-grid overview-detail">
	<div class="col-4">
		<div class="overview-number">
			<div *ngIf="venueService.productStatisticMetric.value.data">
				<span *ngIf="metricDateView === 1">{{ day?.visits }}</span>
				<span *ngIf="metricDateView === 2">{{ week?.visits }}</span>
				<span *ngIf="metricDateView === 3">{{ month?.visits }}</span>
			</div>

			<span *ngIf="!venueService.productStatisticMetric.value.data">
				<p-skeleton></p-skeleton>
			</span>
		</div>
		<div class="overview-subtext">visits</div>
	</div>
	<div class="col-4">
		<div class="overview-number">
			<div *ngIf="venueService.productStatisticMetric.value.data">
				<span *ngIf="metricDateView === 1">{{ day?.completes }}</span>
				<span *ngIf="metricDateView === 2">{{ week?.completes }}</span>
				<span *ngIf="metricDateView === 3">{{ month?.completes }}</span>
			</div>

			<span *ngIf="!venueService.productStatisticMetric.value.data">
				<p-skeleton></p-skeleton>
			</span>
		</div>
		<div class="overview-subtext">completed orders</div>
	</div>
	<div class="col-4">
		<div class="overview-number">
			<div *ngIf="venueService.productStatisticMetric.value.data">
				<span *ngIf="metricDateView === 1">{{ day?.abandons }}</span>
				<span *ngIf="metricDateView === 2">{{ week?.abandons }}</span>
				<span *ngIf="metricDateView === 3">{{ month?.abandons }}</span>
			</div>

			<span *ngIf="!venueService.productStatisticMetric.value.data">
				<p-skeleton></p-skeleton>
			</span>
		</div>
		<div class="overview-subtext">abandoned carts</div>
	</div>

	<div class="d-flex flex-column w-100">
		<div class="mx-auto">
			<span *ngIf="metricDateView === 1">today</span>
			<span *ngIf="metricDateView === 2">this week</span>
			<span *ngIf="metricDateView === 3">this month</span>
			<fa-icon [icon]="['far', 'calendar']" (click)="changeMetricDate()" class="ms-4"></fa-icon>
		</div>
		<span class="p-float-label">
			<p-dropdown
				#productSelectPickList
				[options]="productList"
				optionLabel="label"
				optionValue="value"
				name="productSelectPickList"
				[(ngModel)]="productSelected"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				(filterBy)="app.keys(productList)"
				(onChange)="applyProductFilter()"
			></p-dropdown>
			<label for="productSelectPickList">Product</label>
		</span>

		<p-divider></p-divider>
		<p-skeleton *ngIf="!chartConfig.data" height="100%" width="100%"></p-skeleton>
		<p-chart #productPerformance type="line" [data]="chartConfig.data" [options]="chartConfig"></p-chart>
	</div>
</div>
